import { RegisterForm } from '@/components/auth/RegisterForm';

export function Register() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <RegisterForm />
    </div>
  );
}